export default {
  title: 'Páginas',
  description: 'Gerencie as páginas dentro do website.',
  labels: {
    new: 'Nova Página',
  },
  form: {
    title: 'Cadastro de Página'
  },
  groups: {
    filter: 'Filtro',
    generalData: 'Dados gerais',
  },
  fields: {
    content: 'Conteúdo',
    is_draft: 'Rascunho',
    is_published: 'Publicado',
    language: 'Idioma',
    layout: 'Layout',
    max_depth: 'Limite de itens',
    name: 'Nome da página',
    page_type: 'Tipo de página',
    plan: 'Plano',
    preview:'Preview',
    slug: 'Slug',
    status: 'Status',
    url: 'URL',
    website: 'Website',
  }
};
